import { gsap } from "@gsap";

// Usage: data-reveal="up|left" on a group, data-reveal-item on the children that
// should stagger in. Without items the group itself is revealed.
const offsets = {
    up: { y: 24 },
    left: { x: 24 },
};

document.addEventListener("DOMContentLoaded", () => {
    const groups = gsap.utils.toArray("[data-reveal]");
    if (!groups.length) return;

    const mm = gsap.matchMedia();

    mm.add("(prefers-reduced-motion: no-preference)", () => {
        groups.forEach((group) => {
            const items = group.querySelectorAll("[data-reveal-item]");
            const offset = offsets[group.dataset.reveal] || offsets.up;

            gsap.fromTo(items.length ? items : group, { opacity: 0, ...offset }, {
                opacity: 1,
                x: 0,
                y: 0,
                duration: 0.6,
                ease: "power2.out",
                stagger: 0.1,
                clearProps: "opacity,transform",
                scrollTrigger: {
                    trigger: group,
                    start: "top 80%",
                    once: true,
                },
            });
        });
    });
});
